import React from 'react';
import moment from "moment";
import {PAGINATION} from "ubs-framework/v2/common/constant";
import {JOB_TYPE, REQUISITION, STATUS_OPTIONS} from "../../common/constant";

export const startDate = new Date(moment().subtract(6, 'days').set({'hour': 0, 'minute': 0, 'second': 0}));
export const endDate = new Date(moment().set({'hour': 0, 'minute': 0, 'second': 0}));

export const startDateMonth = new Date(moment().startOf('month'));
export const endDateMonth = new Date(moment().endOf('month'));
export const threePrevMonth = new Date(moment().subtract(2, 'months').startOf('month'))

export const monthStart = new Date(moment().startOf('month')).getTime();
export const monthEnd = new Date(moment().endOf('month')).getTime();

export const yearStart = new Date(moment().startOf('year')).getTime();
export const yearEnd = new Date(moment().endOf('year')).getTime();

export const previousMonth = new Date(moment().subtract(1, 'months').startOf('month')).getTime();

export const nextYear = (start) => {
    return new Date(moment(start).add({'year': 1}).subtract(1, 'days')).getTime()
};

export const previous7DayStart = new Date(moment().subtract(6, 'days').startOf('day')).getTime();
export const todayEnd = new Date(moment().endOf('day')).getTime();

export const thirdMonthStart = new Date(new Date(moment().startOf('month')).setMonth(new Date().getMonth() + 2)).getTime()
export const thirdMonthEnd = new Date(new Date(moment().endOf('month')).setMonth(new Date().getMonth() + 2)).getTime()


const initialState = {
    socketId: '',
    _id: '',
    auditLogs: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        createdBy: null,
        createdAt: {
            startDate,
            endDate,
        }
    },
    jobTemplate: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        location: null
    },
    importSummaryReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        status: null,
        user: null,
        startDate,
        endDate,
    },
    requisitions: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        location: null,
        jobTitle: null,
        priority: null,
        // Requisitions open on the pending queue by default.
        status: STATUS_OPTIONS.find(_ => _?.value === REQUISITION.STATUS.PENDING) || null,
    },
    jobs: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        location: [],
        jobTitle: [],
        hiringManager: null,
        hiringTeam: null,
        openingDate: null,
        expireDate: null,
        jobPostType: null,
        isClose: JOB_TYPE.STATUS[0],
        jobType: null,
        priority: null,
        jobStatus: null,
    },
    jobDetailCandidate: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        from: '',
        to: '',
        location: null,
        stageManager: null,
        source: null,
        view: 'kanban',
        candidateType: 'active',
    },
    jobWiseCandidate: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        }
    },
    stageWiseCandidate:{
      currentPage: PAGINATION.CURRENT_PAGE,
      limit: PAGINATION.LIMIT,
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        }
    },
    recruiterCandidate: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        }
    },
    recruiterPerformance: {
        recruiter: null, // selected recruiter option ({label,value,_id,...}); null = resolve to logged-in user on mount
        createdAt: {
            startDate: new Date(moment().add(-30, 'days').endOf('day')).getTime(),
            endDate: new Date(moment().startOf('day')).getTime()
        },
        value: {value: 'last30', label: 'Last 30 Days'} // active date preset (mirrors REPORT_DATE)
    },
    jobSummary: {
        job: null, // selected job option ({label,value,profileImage}); null = job-scoped widgets idle, all-jobs cards still load
        createdAt: {
            startDate: new Date(moment().add(-30, 'days').endOf('day')).getTime(),
            endDate: new Date(moment().startOf('day')).getTime()
        },
        value: {value: 'last30', label: 'Last 30 Days'}
    },
    teamSummary: {
        team: null, // selected team option ({label,value}); null until the first team is auto-selected on load
        createdAt: {
            startDate: new Date(moment().add(-30, 'days').endOf('day')).getTime(),
            endDate: new Date(moment().startOf('day')).getTime()
        },
        value: {value: 'last30', label: 'Last 30 Days'}
    },
    disqualifyCandidate:{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        }
    },
    sourceWiseCandidate:{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        }
    },
    jobsHiringReport:{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        }
    },
    jobWiseInterviewReport :{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        }
    },
    archiveJobsReport:{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        }
    },
    archiveCandidateReport:{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        },
        candidateType: 204
    },
    activeCandidateReport:{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        },
        candidateType: 207
    },
    downloadRequestReport:{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
    },
    mailStatusReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        type: 14,
        emailType: '',
        filter: {
            startDate: monthStart,
            endDate: new Date(moment().endOf('day')).getTime(),
            status: 1
        },
    },
    referralList:{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        referredBy:'',
        referredFor: '',
        date: '',
        referralBy: '',
        createdBy: ''
    },
    remarkOrg:{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search:'',
        remarkBy:'',
        remarkAt:'',
        jobId:'',
        candidateType: 'active'
    },
    remarkOtherOrg:{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search:'',
        createdBy:'',
        createdAt:'',
        jobTitle:'',
        job:'',
        candidateType: 'active'
    },
    yourOrgList:{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search:'',
        sharedBy:'',
        sharedAt:'',
        jobTitle:'',
        jobId:'',
        candidateType: 'active'
    },
    otherOrgList:{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search:'',
        createdBy:'',
        createdAt:'',
        jobTitle:'',
        job:'',
        candidateType: 'active'
    },
    verifyYourOrgList:{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search:'',
        type: 1,
        requestBy: '',
        createdAt:'',
        jobTitle:'',
        job:'',
        status: '',
        candidateType: 'active'
    },
    orgStructure: {
        bands: {
            currentPage: PAGINATION.CURRENT_PAGE,
            limit: PAGINATION.LIMIT,
            search: '',
            type: 3,
        },
        grade: {
            currentPage: PAGINATION.CURRENT_PAGE,
            limit: PAGINATION.LIMIT,
            search: '',
            type: 9,
        },
    },
    verifyOtherOrgList:{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search:'',
        type: 2,
        requestBy: '',
        createdAt:'',
        job:'',
        status: '',
        jobName:'',
        candidateType: 'active'
    },
    jobReport: {
        createdAt: {
            startDate,
            endDate,
        }
    },
    activityFilter:{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        createdAt: null,
        type: null,
        candidate: null,
        user: null,
    },
    candidateActivityFilter:{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        createdAt: '',
        user: null,
        activityType: null,
    },
    candidateInterviewFilter: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        date: null,
        job: '',
        candidate: '',
    },
    evaluationFilter: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        requestedBy: null,
        requestedTo: null,
        givenBy: null,
        status: null,
    },
    offerLetterApproval: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
    },
    masterJobTitle: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
    },
    masterDegree: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
    },
    masterDepartment: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
    },
    masterLocation: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
    },
    offerLetterReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        status: [],
        joiningAt :{
            startDate: null,
            endDate: null,
        },
        acceptAt :{
            startDate: null,
            endDate: null
        },
        releaseAt :{
            startDate: null,
            endDate: null
        },
        declineAt :{
            startDate: null,
            endDate: null
        },
        createAt :{
            startDate: null,
            endDate: null
        },
    },
    timeToFill:{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        },
        status:  {label: 'Group By : All', value: 1},
    },
    employeeTurnoverRate:{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        },
        status:  {label: 'Group By : All', value: 1},
    },
    offerAcceptanceRate:{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        },
        status:  {label: 'Group By : All', value: 1},
    },
    fillRate:{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        },
        status:  {label: 'Group By : All', value: 1},
    },
    interviewToOfferRatio:{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        },
        status:  {label: 'Group By : All', value: 1},
    },
    recruitmentPipelineStatus:{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        },
        status:  {label: 'Group By : All', value: 1},
        stage: null
    },
    RejectedAndHoldCandidates:{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        },
        status:  {label: 'Group By : All', value: 1},
        rejectReasonId: [],
    },
    openingVsApplicationVsOnboarding :{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        },
        status:  {label: 'Group By : All', value: 1},
    },
    offerReleasedVsOfferAcceptance:{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        },
        status:  {label: 'Group By : All', value: 1},
    },
    diversityHiring:{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        },
        status:  {label: 'Group By : All', value: 1},
    },
    jobwiseStatuswiseTagwise :{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        },
    },
    workforceForecastVsActual :{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        },
        status:  {label: 'Group By : All', value: 1},
    },
    budgetForecastVsActualSpend : {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        },
        status: {label: 'Group By : All', value: 1},
    },
    screeningEfficiency : {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        },
        status: {label: 'Group By : All', value: 1},
    },
    sourcewiseConversionRate : {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        },
        status: {label: 'Group By : All', value: 1},
    },
    funnelOfJobOpeningStages : {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        createdAt: {
            startDate: startDateMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        },
        status: {label: 'Group By : All', value: 1},
    },
    // CEO Overview dashboard date filter
    ceoOverview: {
        // defaults to the last month (e.g. 6 Sep - 6 Oct); the user can pick any range from the Date Range picker
        createdAt: {
            startDate: moment().subtract(1, 'month').startOf('day').valueOf(),
            endDate: moment().endOf('day').valueOf(),
        },
    },
};


export default function (state = initialState, action) {
    switch (action.type) {
        case 'SOCKET_CONNECTION': {
            return {...state, socketId: action.payload};
        }
        case 'AUTHENTICATE': {
            const data = {}
            if (action.payload) data._id = action.payload._id
            return {...state, ...data};
        }
        case 'GET_ATS_MASTER_DATA': {
            return {...state}
        }


        /** Job Filter **/
        case 'FILTER_JOBS': {
            return {...state, jobs: {...state.jobs, ...action.payload}}
        }
        case 'FILTER_JOB_DETAIL_CANDIDATE': {
            return {...state, jobDetailCandidate: {...state.jobDetailCandidate, ...action.payload}}
        }

        /** Requisitions Filter **/
        case 'FILTER_REQUISITIONS': {
            return {...state, requisitions: {...state.requisitions, ...action.payload}}
        }

        /** Settings Filter **/
        case 'FILTER_AUDIT_LOGS': {
            return {...state, auditLogs: {...state.auditLogs, ...action.payload}}
        }
        case 'FILTER_JOB_TEMPLATES': {
            return {...state, jobTemplate: {...state.jobTemplate, ...action.payload}}
        }
        case 'FILTER_IMPORT_SUMMARY_REPORT': {
            return {...state, importSummaryReport: {...state.importSummaryReport, ...action.payload}}
        }
        case 'FILTER_JOB_REPORT': {
            return {...state, jobReport: {...state.jobReport, ...action.payload}}
        }
        case 'FILTER_JOB_WISE_CANDIDATE': {
            return {...state, jobWiseCandidate: {...state.jobWiseCandidate, ...action.payload}}
        }
        case 'FILTER_RECRUITER_WISE_CANDIDATE': {
            return {...state, recruiterCandidate: {...state.recruiterCandidate, ...action.payload}}
        }
        case 'FILTER_RECRUITER_PERFORMANCE': {
            return {...state, recruiterPerformance: {...state.recruiterPerformance, ...action.payload}}
        }
        case 'FILTER_JOB_SUMMARY': {
            return {...state, jobSummary: {...state.jobSummary, ...action.payload}}
        }
        case 'FILTER_TEAM_SUMMARY': {
            return {...state, teamSummary: {...state.teamSummary, ...action.payload}}
        }
        case 'FILTER_STAGE_WISE_CANDIDATE': {
            return {...state, stageWiseCandidate: {...state.stageWiseCandidate,...action.payload}}
        }
        case 'SET_ORG_STRUCTURE_SETTING_FILTER': {
            return {...state, orgStructure: {...state.orgStructure, ...action.payload}}
        }
        case 'FILTER_DISQUALIFY_CANDIDATE':{
            return {...state, disqualifyCandidate: {...state.disqualifyCandidate,...action.payload}}
        }
        case 'FILTER_SOURCE_WISE_CANDIDATE':{
            return {...state,sourceWiseCandidate: {...state.sourceWiseCandidate,...action.payload}}
        }
        case 'FILTER_JOB_HIRING_REPORT':{
            return {...state,jobsHiringReport: {...state.jobsHiringReport,...action.payload}}
        }
        case 'FILTER_JOB_WISE_INTERVIEWS':{
            return {...state,jobWiseInterviewReport: {...state.jobWiseInterviewReport,...action.payload}}
        }
        case 'FILTER_ARCHIVE_JOB_REPORT':{
           return {...state,archiveJobsReport: {...state.archiveJobsReport,...action.payload}}
        }
        case 'FILTER_ARCHIVE_CANDIDATE_REPORT':{
            return {...state,archiveCandidateReport: {...state.archiveCandidateReport,...action.payload}}
        }
        case 'FILTER_ACTIVE_CANDIDATE_REPORT':{
            return {...state,activeCandidateReport: {...state.activeCandidateReport,...action.payload}}
        }
        case 'FILTER_DOWNLOAD_REQUEST_REPORT':{
            return {...state,downloadRequestReport: {...state.downloadRequestReport,...action.payload}}
        }
        case 'FILTER_MAIL_STATUS_REPORT':{
            return {...state,mailStatusReport: {...state.mailStatusReport,...action.payload}}
        }
        case 'FILTER_REFERRAL_LIST':{
            return {...state,referralList: {...state.referralList,...action.payload}}
        }
        case 'FILTER_REMARK_ORG_LIST':{
            return {...state,remarkOrg: {...state.remarkOrg,...action.payload}}
        }
        case 'FILTER_REMARK_OTHER_ORG_LIST':{
            return {...state,remarkOtherOrg: {...state.remarkOtherOrg,...action.payload}}
        }
        case 'FILTER_SHARE_LIST':{
            return {...state,yourOrgList: {...state.yourOrgList,...action.payload}}
        }
        case 'FILTER_OTHER_LIST':{
            return {...state,otherOrgList: {...state.otherOrgList,...action.payload}}
        }
        case 'FILTER_VERIFY_YOUR_LIST':{
            return {...state,verifyYourOrgList: {...state.verifyYourOrgList,...action.payload}}
        }
        case 'FILTER_VERIFY_OTHER_LIST':{
            return {...state,verifyOtherOrgList: {...state.verifyOtherOrgList,...action.payload}}
        }
        case 'JOBS_ACTIVITY_FILTER':{
            return {...state,activityFilter: {...state.activityFilter,...action.payload}}
        }
        case 'CANDIDATE_ACTIVITY_FILTER':{
            return {...state,candidateActivityFilter: {...state.candidateActivityFilter,...action.payload}}
        }
        case 'CANDIDATE_INTERVIEW_FILTER':{
            return {...state,candidateInterviewFilter: {...state.candidateInterviewFilter,...action.payload}}
        }
        case 'FILTER_EVALUATION': {
            return { ...state, evaluationFilter: { ...state.evaluationFilter, ...action.payload } }
        }
        case 'OFFER_LETTER_APPROVAL': {
            return {...state, offerLetterApproval: {...state.offerLetterApproval, ...action.payload}}
        }
        case 'SET_JOB_TITLE_LIST': {
            return {...state, masterJobTitle: {...state.masterJobTitle, ...action.payload}};
        }
        case 'SET_DEGREE_LIST': {
            return { ...state, masterDegree: { ...state.masterDegree, ...action.payload } };
        }
        case 'SET_MASTER_DEPARTMENT_LIST': {
            return {...state, masterDepartment: {...state.masterDepartment, ...action.payload}};
        }
        case 'SET_MASTER_LOCATION_LIST': {
            return {...state, masterLocation: {...state.masterLocation, ...action.payload}};
        }
        case 'FILTER_OFFER_LETTER_REPORT': {
            return {...state, offerLetterReport: {...state.offerLetterReport, ...action.payload}};
        }
        case 'FILTER_TIME_TO_FILL': {
            return {...state, timeToFill: {...state.timeToFill,...action.payload}}
        }
        case 'FILTER_EMPLOYEE_TURNOVER_RATE': {
            return {...state, employeeTurnoverRate: {...state.employeeTurnoverRate,...action.payload}}
        }
        case 'FILTER_OFFER_ACCEPTANCE_RATE': {
            return {...state, offerAcceptanceRate: {...state.offerAcceptanceRate,...action.payload}}
        }
        case 'FILTER_FILL_RATE': {
            return {...state, fillRate: {...state.fillRate,...action.payload}}
        }
        case 'FILTER_INTERVIEW_TO_OFFER_RATIO': {
            return {...state, interviewToOfferRatio: {...state.interviewToOfferRatio,...action.payload}}
        }
        case 'FILTER_RECRUITMENT_PIPELINE_STATUS': {
            return {...state, recruitmentPipelineStatus: {...state.recruitmentPipelineStatus,...action.payload}}
        }
        case 'FILTER_REJECTED_AND_HOLD_CANDIDATES': {
            return {...state, RejectedAndHoldCandidates: {...state.RejectedAndHoldCandidates,...action.payload}}
        }
        case 'FILTER_OPENING_VS_APPLICATION_VS_ONBOARDING': {
            return {...state, openingVsApplicationVsOnboarding: {...state.openingVsApplicationVsOnboarding,...action.payload}}
        }
        case 'FILTER_OFFER_RELEASED_VS_OFFER_ACCEPTANCE': {
            return {...state, offerReleasedVsOfferAcceptance: {...state.offerReleasedVsOfferAcceptance,...action.payload}}
        }
        case 'FILTER_DIVERSITY_HIRING': {
            return {...state, diversityHiring: {...state.diversityHiring,...action.payload}}
        }
        case 'FILTER_JOBWISE_STATUSWISE_TAGWISE': {
            return {...state, jobwiseStatuswiseTagwise: {...state.jobwiseStatuswiseTagwise,...action.payload}}
        }
        case 'FILTER_WORKFORCE_FORECAST_VS_ACTUAL': {
            return {...state, workforceForecastVsActual: {...state.workforceForecastVsActual,...action.payload}}
        }
        case 'FILTER_BUDGET_FORECAST_VS_ACTUAL_SPEND': {
            return {...state, budgetForecastVsActualSpend: {...state.budgetForecastVsActualSpend,...action.payload}}
        }
        case 'FILTER_SCREENING_EFFICIENCY': {
            return {...state, screeningEfficiency: {...state.screeningEfficiency,...action.payload}}
        }
        case 'FILTER_SOURCE_WISE_CONVERSION_RATE': {
            return {...state, sourcewiseConversionRate: {...state.sourcewiseConversionRate,...action.payload}}
        }
        case 'FILTER_FUNNEL_OF_JOB_OPENING_STAGES': {
            return {...state, funnelOfJobOpeningStages: {...state.funnelOfJobOpeningStages,...action.payload}}
        }
        case 'FILTER_CEO_OVERVIEW': {
            return {...state, ceoOverview: {...state.ceoOverview, ...action.payload}}
        }
        default: {
            return state;
        }
    }
}
